import { Box, Container, Stack, type SxProps } from '@mui/material'

import catHeaderImage from '@/assets/cat_header_image.jpg'
import perkinsHeaderImage from '@/assets/perkins_header_image.jpg'
import { getMediaState } from '@/features/media/slice'
import { useAppSelector } from '@/redux/hooks'

export default () => {
  const { isPerkins, headerMessage } = useAppSelector(getMediaState)
  const height = '64px'
  const headerImage = isPerkins ? perkinsHeaderImage : catHeaderImage
  const bgColor = isPerkins ? '#00529C' : '#282828'

  const wrapperStyle: SxProps = {
    overflow: 'hidden',
  }

  const headerImageStyle: SxProps = {
    height: '100%',
    backgroundImage: {
      md: `url(${headerImage})`,
    },
    backgroundPosition: 'top right',
    backgroundAttachment: 'scroll',
    backgroundSize: `auto ${height}`,
    backgroundRepeat: 'no-repeat',
    overflowY: 'auto',
  }

  return (
    <Box color="#fff" bgcolor={bgColor} height={height} sx={wrapperStyle}>
      <Container maxWidth="xl" sx={headerImageStyle}>
        <Stack
          minHeight={height}
          marginY="auto"
          justifyContent="center"
          alignItems="start"
          dangerouslySetInnerHTML={{ __html: headerMessage }}
        />
      </Container>
    </Box>
  )
}
